<template>
  <v-card>
    <form @submit.prevent="submit">
      <v-card-text>
        <v-layout row wrap>
          <v-flex
            xs12 sm6
            v-for="field in fields" :key="field.key">
            <v-text-field
              v-model="search[field.key]"
              :label="field.label">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              :label="$t('user.search.labels.locked')"
              v-model="locked">
            </v-switch>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              :label="$t('user.search.labels.risky_at')"
              v-model="risky_at">
            </v-switch>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-row actions>
        <v-btn light @click.native="clear" secondary class="mr-2">{{ $t('user.search.clear') }}</v-btn>
        <v-btn light type="submit" primary>{{ $t('user.search.submit') }}</v-btn>
      </v-card-row>
    </form>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      search: {
        first_name_cont: this.value.first_name_cont,
        last_name_cont: this.value.last_name_cont,
        email_cont: this.value.email_cont,
        phone_cont: this.value.phone_cont,
        nickname_cont: this.value.nickname_cont
      },
      locked: this.value.locked_at_not_null,
      risky_at: this.value.risky_at_not_null
    }
  },
  computed: {
    fields () {
      return ['first_name_cont', 'last_name_cont', 'nickname_cont', 'email_cont', 'phone_cont']
        .map(key => ({
          key,
          label: this.$t(`user.search.labels.${key}`)
        }))
    }
  },
  methods: {
    clear () {
      this.$emit('input', {})
    },
    submit () {
      this.$emit('input', {
        ...this.search,
        ...this.locked
          ? { locked_at_not_null: true }
          : {},
        ...this.risky_at
          ? { risky_at_not_null: true }
          : {}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Search.vue